<template>
  <div id="PrivacyP" >
    <b-container>
        <h3 class="title">Terms and Conditions</h3>
        <p class="description">
            
        </p>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Privacy Policy',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    isMobile() {
        if( screen.width <= 1280 ) {
            return true;
        }
        else {
            return false;
        }
    },
  },
  mounted() {
    axios //add API Call
        .get(
           'https://wp-ocssport.ocs-sport.com/' + 'thegrass' + "/wp-json/wp/v2/pages/13" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>
<style scoped>
#PrivacyP {
    padding-top: 100px;
    padding-bottom: 100px;
}
.images {
    width: 100%;
}
.title {
    font-size: 50px;
    font-family: DIN Condensed, Bold;
    color: #0054E8;
    text-align: left;
    padding-bottom: 50px;
}
p {
    text-align: left;
    font-size: 24px;
    color: #000000;
    padding-bottom: 50px;
}
button.getintouch {
    padding: 14px 14px 14px 14px;
    background-color: #2CD55B;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #2CD55B;
    font-size: 24px;
    font-weight: bold;
    float: left;
}
button.getintouch:hover {
    padding: 14px 14px 14px 14px;
    background-color: #0054E8;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #0054E8;
    font-size: 24px;
    font-weight: bold;
    float: left;
}

/* Css for mobile */
@media only screen and (max-width: 1280px) {
    #Howpinpisworks {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .title {
        padding-bottom: 20px;
    }
    p {
        text-align: left;
        font-size: 18px;
        color: #000;
        padding-bottom: 10px;
    }
    button.getintouch {
        padding: 14px 14px 14px 14px;
        background-color: #2CD55B;
        height: auto;
        color: #000;
        border-radius: 14px;
        border-color: #2CD55B;
        font-size: 18px;
        font-weight: bold;
        float: left;
    }
    button.getintouch:hover {
        padding: 14px 14px 14px 14px;
        background-color: #0054E8;
        height: auto;
        color: #fff;
        border-radius: 14px;
        border-color: #0054E8;
        font-size: 18px;
        font-weight: bold;
        float: left;
    }
}
</style>
